"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConnectedWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _index = _interopRequireDefault(require("./sagas/index"));
var _index2 = _interopRequireDefault(require("./reducers/index"));
var _TranslationContext = require("./context/TranslationContext");
var _App = _interopRequireDefault(require("./components/App"));
var _PropsContext = require("./context/PropsContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Widget = function Widget(_ref) {
  var i18n = _ref.i18n,
    language = _ref.language,
    __instanceId = _ref.__instanceId,
    __pageId = _ref.__pageId,
    showChangeTariff = _ref.showChangeTariff,
    title = _ref.title,
    unlimitedValue = _ref.unlimitedValue;
  var t = i18n ? function (key, options) {
    var tr = i18n(key, options);
    return tr || key;
  } : function (key) {
    return key;
  };
  if (!language) return null;
  return /*#__PURE__*/_react.default.createElement(_TranslationContext.TranslationProvider, {
    t: t
  }, /*#__PURE__*/_react.default.createElement(_PropsContext.PropsProvider, {
    widgetProps: {
      __instanceId: __instanceId,
      __pageId: __pageId,
      showChangeTariff: showChangeTariff,
      title: title,
      unlimitedValue: unlimitedValue,
      language: language
    }
  }, /*#__PURE__*/_react.default.createElement(_App.default, {
    instanceId: __instanceId,
    pageId: __pageId
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    language: state.language.language
  };
};
var ConnectedWidget = (0, _reactRedux.connect)(mapStateToProps)(Widget);
exports.ConnectedWidget = ConnectedWidget;
var exported = ConnectedWidget;
var _default = exported;
exports.default = _default;
Widget.propTypes = {
  i18n: _propTypes.default.any,
  language: _propTypes.default.any,
  __instanceId: _propTypes.default.string,
  __pageId: _propTypes.default.string,
  showChangeTariff: _propTypes.default.bool,
  title: _propTypes.default.string,
  unlimitedValue: _propTypes.default.number
};
exported.reducer = _index2.default;
exported.sagas = _index.default;